import QrCode from 'assets/svg/CopytradingDropdown/copytrading_qr.svg'
import React from 'react'
import styled from 'styled-components'

export const DropdownCopytradingAppInfo = () => {
  return (
    <StyledDropdownCopytradingAppInfo>
      <Label>Copy Trading App</Label>
      <QrCodeContainer />

      <QrCodeLabel>
        Scan to Download App
        <br /> iOS & Android
      </QrCodeLabel>

      <DownloadButton rel='noopener noreferrer' href={`https://copytrading.margex.com/2qXj`}>
        Download App
      </DownloadButton>
    </StyledDropdownCopytradingAppInfo>
  )
}

const Label = styled.span`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
`

const StyledDropdownCopytradingAppInfo = styled.div`
  width: 264px;
  height: 100%;
  background: linear-gradient(180deg, #1743a7 0%, #1743a7 100%);
  border-radius: 8px 0px 0px 8px;
  padding: 32px;
  text-align: center;
`

const QrCodeLabel = styled.span`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #c0d8ff;
  margin-top: 12px;
`

const DownloadButton = styled.a`
  width: 100%;
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  background: #3071ee;
  border: 1px solid #3071ee;
  display: block;
  padding: 8px 0;
  border-radius: 4px;
  margin-top: 12px;
`

const QrCodeContainer = styled.div`
  margin: 19px auto 0;
  width: 176px;
  height: 176px;
  background-image: url(${QrCode});
  border-radius: 4px;
`
